import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import SearchBoxModal from "../component/SearchBoxModal";

// Trang tra cứu lịch sử thay đổi của nhân viên (giải trình / đăng ký / chấm công).
// 2 tab:
//  - Tab A "Bản ghi của nhân viên bị thay đổi": endpoint lichsu_nhanvien (lọc theo tableid các
//    bản ghi thuộc NV). Cần chọn nhân viên trước.
//  - Tab B "Thao tác do nhân viên thực hiện": endpoint logs (lọc user_id = id nhân viên thao tác).
// Log lưu MongoDB qua Node service; backend proxy sẵn (GET /api/logs, GET /api/lichsu_nhanvien).

const TABLE_LABEL = {
  giaitrinh: "Giải trình",
  users_break: "Đăng ký (nghỉ/công tác/NVP)",
  users_onday: "Chấm công",
};
const ACTION_LABEL = { insert: "Thêm mới", update: "Cập nhật", delete: "Xóa" };

export default function TraCuuLichSu() {
  const [tab, setTab] = useState("A"); // A = bản ghi của NV, B = thao tác do NV làm
  const [userCode, setUserCode] = useState("");     // mã NV (cho tab A)
  const [userId, setUserId] = useState("");         // id NV (cho tab B - người thao tác)
  const [tablename, setTablename] = useState("");
  const [action, setAction] = useState("");
  const [filterShow, setFilterShow] = useState(true);

  // Tab A dùng user_code; Tab B dùng user_id (id người thao tác). SearchBoxModal users trả 'code',
  // nên cho tab B ta chọn NV theo id: dùng colvalue='id'.
  const [paramA, setParamA] = useState("");
  const [paramB, setParamB] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (tab === "A") {
      let p = "";
      if (userCode) p += "&user_code=" + userCode;
      if (tablename) p += "&tablename=" + tablename;
      setParamA(p);
    } else {
      let p = "";
      if (userId) p += "&user_id=" + userId;
      if (tablename) p += "&tablename=" + tablename;
      if (action) p += "&action=" + action;
      setParamB(p);
    }
  };

  // Render diff cũ→mới từ update_value / newdata
  const renderChange = (value, tableMeta) => {
    const row = tableMeta || {};
    const uv = row.update_value;
    if (uv && typeof uv === "object" && Object.keys(uv).length > 0) {
      return (
        <div style={{ minWidth: 220 }}>
          {Object.keys(uv).map((k) => (
            <div key={k}>
              <small><strong>{k}</strong>: </small>
              <span style={{ color: "#c00" }}>{String(row.olddata ? row.olddata[k] : "")}</span>
              {" → "}
              <span style={{ color: "#080" }}>{String(uv[k])}</span>
            </div>
          ))}
        </div>
      );
    }
    if (row.action === "insert") return <em>Thêm mới bản ghi</em>;
    if (row.action === "delete") return <em>Xóa bản ghi</em>;
    return "";
  };

  const columns = [
    {
      name: "created_at", label: "Thời gian",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta) => {
          const v = value || tableMeta.datecreate;
          if (!v) return "";
          try { return new Date(v).toLocaleString("vi-VN"); } catch (e) { return v; }
        },
      },
    },
    {
      name: "user_info", label: "Người thực hiện",
      options: {
        filter: false, sort: false,
        customBodyRender: (value, tableMeta) => {
          const u = tableMeta.user_info;
          if (!u) return <span>{tableMeta.user_id}</span>;
          return <div style={{ minWidth: 160 }}><strong>{u.fullname}</strong><br /><small>{u.code}</small></div>;
        },
      },
    },
    {
      name: "tablename", label: "Loại",
      options: { customBodyRender: (v) => TABLE_LABEL[v] || v },
    },
    {
      name: "action", label: "Hành động",
      options: { customBodyRender: (v) => ACTION_LABEL[v] || v },
    },
    { name: "tableid", label: "Mã bản ghi" },
    {
      name: "update_value", label: "Chi tiết thay đổi",
      options: { filter: false, sort: false, customBodyRender: renderChange },
    },
  ];

  return (
    <AkkhorLayout idrole="tra-cuu-lich-su">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li>Tra cứu lịch sử thay đổi nhân viên</li>
        </ul>
      </div>

      <div className="card card-filter mb-3">
        <div className="card-header">
          <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
            <div className="mr-auto"><h3 className="title">Tìm kiếm</h3></div>
            <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
          </div>
        </div>
        <div className={filterShow ? "card-body" : "hidden-filter"}>
          {/* Tabs */}
          <ul className="nav nav-tabs mb-3">
            <li className="nav-item">
              <button type="button" className={"nav-link " + (tab === "A" ? "active" : "")} onClick={() => setTab("A")}>
                Bản ghi CỦA nhân viên bị thay đổi
              </button>
            </li>
            <li className="nav-item">
              <button type="button" className={"nav-link " + (tab === "B" ? "active" : "")} onClick={() => setTab("B")}>
                Thao tác DO nhân viên thực hiện
              </button>
            </li>
          </ul>

          <form className="new-added-form" method="get">
            <div className="row">
              {tab === "A" ? (
                <div className="col-lg-3 col-md-6 col-12 form-group">
                  <label>Nhân viên (bản ghi thuộc về)</label>
                  <SearchBoxModal apiname={"users"} placeholder="Chọn nhân viên" colvalue={"code"} colname={"fullname"} name="user_code"
                    onChange={(e) => setUserCode(e)} />
                </div>
              ) : (
                <div className="col-lg-3 col-md-6 col-12 form-group">
                  <label>Nhân viên (người thao tác)</label>
                  <SearchBoxModal apiname={"users"} placeholder="Chọn nhân viên" colvalue={"id"} colname={"fullname"} name="user_id"
                    onChange={(e) => setUserId(e)} />
                </div>
              )}

              <div className="col-lg-3 col-md-6 col-12 form-group">
                <label>Loại dữ liệu</label>
                <select className="form-select height32" value={tablename} onChange={(e) => setTablename(e.target.value)}>
                  <option value="">Tất cả</option>
                  <option value="giaitrinh">Giải trình</option>
                  <option value="users_break">Đăng ký (nghỉ/công tác/NVP)</option>
                  <option value="users_onday">Chấm công</option>
                </select>
              </div>

              {tab === "B" && (
                <div className="col-lg-3 col-md-6 col-12 form-group">
                  <label>Hành động</label>
                  <select className="form-select height32" value={action} onChange={(e) => setAction(e.target.value)}>
                    <option value="">Tất cả</option>
                    <option value="insert">Thêm mới</option>
                    <option value="update">Cập nhật</option>
                    <option value="delete">Xóa</option>
                  </select>
                </div>
              )}

              <div className="col-12">
                <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Tra cứu</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {tab === "A" ? (
        <SRList key="tabA" name="lichsu_nhanvien" idrole="tra-cuu-lich-su" params={paramA}
          title="Lịch sử thay đổi các bản ghi của nhân viên" defaultLimit={30} serverSide={true}
          columns={columns} onlyList={true} noAction={true} />
      ) : (
        <SRList key="tabB" name="logs" idrole="tra-cuu-lich-su" params={paramB}
          title="Các thao tác do nhân viên thực hiện" defaultLimit={30} serverSide={true}
          columns={columns} onlyList={true} noAction={true} />
      )}
    </AkkhorLayout>
  );
}
